import { createBuilder } from '@sama/js-core';
import { get } from '@sama/micro-dash';
import { Euler } from 'three';
import {
  ShapeLocationOptionsBase,
  ShapeLocationOptionsForStore,
} from '../../../cross-team-shared/test-helpers/builders/answers/build-shape-location';
import { buildCuboidPoints } from '../../../cross-team-shared/test-helpers/builders/build-cuboid-points-3d';
import { defaultGroundZ } from '../../../cross-team-shared/test-helpers/test-context/mock-kd-tree.service.spec-helper.spec';
import {
  Point3D,
  ShapeLocationBase,
} from '../../../team-apis/otterdam/answers/shape-typings';
import { CuboidLocationState3D } from '../../state/cuboid-location-state-3d';
import { pickExisting } from '../../utils/misc-utils';
import { eulerToPoint } from '../../utils/point-cloud-utils';

export type CuboidTransformState = Pick<
  CuboidLocationState3D,
  'position' | 'rotation' | 'scale'
>;
export interface ShapeLocation3DOptions
  extends ShapeLocationOptionsForStore<Point3D> {
  position: Point3D;
  rotation: Point3D;
  scale: Point3D;
}

export const buildCuboidLocation3DForStore = createBuilder<
  CuboidLocationState3D,
  ShapeLocation3DOptions
>((_seq, options) => {
  const cuboidTransformState = buildCuboidTransformState({}, options);
  const points = buildCuboidPoints(cuboidTransformState);
  return {
    ...cuboidTransformState,
    ...buildShapeLocation(
      {},
      {
        points,
        ...options,
      },
    ),
    ...pickExisting(options, 'source'),
  };
});

export const buildCuboidTransformState = createBuilder<
  CuboidTransformState,
  ShapeLocation3DOptions
>((_seq, options) => ({
  ...getCuboidDefaultLocation(options.scale),
  ...pickExisting(options, 'position'),
  ...pickExisting(options, 'rotation'),
  ...pickExisting(options, 'scale'),
}));

const buildShapeLocation = createBuilder<
  ShapeLocationBase<Point3D>,
  ShapeLocationOptionsBase<Point3D>
>((_seq, options) => ({
  frame_number: options.frameNumber || 0,
  visibility: get(options, ['visibility'], 1),
  points: options.points || [],
}));

const defaultScale: Point3D = [2, 5, 1.8];

function getCuboidDefaultLocation(scale = defaultScale): CuboidTransformState {
  return {
    position: [0, 0, defaultGroundZ + scale[2] / 2] as Point3D,
    rotation: eulerToPoint(new Euler(0, 0, 0)),
    scale,
  };
}
